export const categoryIcons = {
  depot: { icon: 'Depot', color: '#2C57D2' },
  family: { icon: 'HeartLine', color: '#A3003F' },
  habitation: { icon: 'Living', color: '#266446' },
  education: { icon: 'Education', color: '#D14800' },
  career: { icon: 'Coins', color: '#A88400' },
  mobility: { icon: 'Mobility', color: '#387F99' },
  travelling: { icon: 'Travel', color: '#5A8700' },
  security: { icon: 'ShieldOutline', color: '#741B78' },
  news: { icon: 'File', color: '#0047FF' },
  precaution: { icon: 'PiggyRight', color: '#9B348E' },
  branch: { icon: 'ChevronRight', color: '#FF0000' },
};
